export default __webpack_public_path__ + "slices/main/assets/public/media/news-card-2@2x.f6ceb56c0e07aa796ed10cc1d10cd707.png";